import React, { useState } from 'react';
import { IconButton, Popover, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FeatureErrorBoundary from 'components/errorBoundary/FeatureErrorBoundary';
import OnboardingChecklist from './OnboardingChecklist';

// The global "?" help launcher in the header. Opens the onboarding checklist
// popup. The checklist is wrapped in a FeatureErrorBoundary so a render failure
// degrades to a fallback instead of crashing the host app.
const OnboardingHelpButton: React.FC = () => {
	const [anchor, setAnchor] = useState<null | HTMLElement>(null);

	return (
		<>
			<Tooltip title="Guided tours & help" arrow placement="bottom">
				<IconButton
					data-tour="nav-help"
					size="small"
					aria-label="guided tours and help"
					onClick={(e) => setAnchor(e.currentTarget)}
					sx={{
						mr: 1.5,
						color: 'text.secondary',
						'&:hover': { color: 'text.primary' },
					}}
				>
					<HelpOutlineIcon sx={{ fontSize: 20 }} />
				</IconButton>
			</Tooltip>
			<Popover
				open={Boolean(anchor)}
				anchorEl={anchor}
				onClose={() => setAnchor(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<FeatureErrorBoundary featureName="Guided tours">
					<OnboardingChecklist onStartTour={() => setAnchor(null)} />
				</FeatureErrorBoundary>
			</Popover>
		</>
	);
};

export default OnboardingHelpButton;
